import axios from '../utils/AxiosInstance'

export default {
  // namespaced: true,
  state: {
    resourceAvailability: null
  },
  mutations: {
    SET_ACCOUNT_RESOURCE_AVAILABILITY (store, value) {
      store.resourceAvailability = value
    }
  },
  getters: {
    getAccountResourceAvailability: (store, getters) => {
      return store.resourceAvailability
    }
  },
  actions: {
    /*
    setAccountResourceAvailability
    */
    setAccountResourceAvailability ({commit, dispatch, getters, state}, filters) {
      return new Promise((resolve, reject) => {
        axios
        .get(`/accounts/${getters.getAccount._id}/resource-availability`)
        .then((response) => {
          commit('SET_ACCOUNT_RESOURCE_AVAILABILITY', response.data)
          resolve(getters.getAccountResourceAvailability)
        })
        .catch((err) => {
          reject(err)
        })
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/accountResourceAvailability.js